import { render, staticRenderFns } from "./InputView.vue?vue&type=template&id=6c6c716a&scoped=true"
import script from "./InputView.vue?vue&type=script&lang=js"
export * from "./InputView.vue?vue&type=script&lang=js"
import style0 from "./InputView.vue?vue&type=style&index=0&id=6c6c716a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6c716a",
  null
  
)

export default component.exports